var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOrangeLockIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 13,
    viewBox: "0 0 10 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.87827 0C3.19709 0 1.82935 1.36774 1.82935 3.04892V4.26848H1.21957C0.546976 4.26848 0 4.81546 0 5.48805V10.9761C0 11.6487 0.546976 12.1957 1.21957 12.1957H8.53697C9.20956 12.1957 9.75654 11.6487 9.75654 10.9761V5.48805C9.75654 4.81546 9.20956 4.26848 8.53697 4.26848H7.92719V3.04892C7.92719 1.36774 6.55944 0 4.87827 0ZM3.04892 3.04892C3.04892 2.04034 3.86969 1.21957 4.87827 1.21957C5.88685 1.21957 6.70762 2.04034 6.70762 3.04892V4.26848H3.04892V3.04892ZM8.53819 10.9761H5.48805V9.58702C5.85087 9.37542 6.09783 8.98638 6.09783 8.53697C6.09783 7.86438 5.55086 7.3174 4.87827 7.3174C4.20568 7.3174 3.6587 7.86438 3.6587 8.53697C3.6587 8.98577 3.90566 9.37542 4.26848 9.58702V10.9761H1.21957V5.48805H8.53697L8.53819 10.9761Z",
    fill: "#FCB248"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrangeLockIcon);
export default __webpack_public_path__ + "static/media/OrangeLockIcon.09f82da276a15d1f2b715de0ee09dceb.svg";
export { ForwardRef as ReactComponent };